export const REPORT_COMPONENT_CONFIG_JS_CODE = `const componentConfig = {
    "reportId": "%reportId%",
    "interactivityProfileName":"%ip%",%ipOverrides%
    "theme":"%themeComposer%",
    "editor": { "placement": "%editorPlacement%" },
    "header": { 
        "showActions": %showActions%,
        "showTitle": %showTitle%,
        "visible": %showHeader%
    }
}`;